export class Datetime {
  dateTimeCode: string;
  dateTime: string;
  dateTimeFormat: string;

  constructor() {
  }
}
